import i18n from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import {initReactI18next} from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import languageEN from './en/translate.json'
import languageLV from './lv/translate.json'
import languageRU from './ru/translate.json'
import languageES from './es/translate.json'
import languageHD from './hd/translate.json'
import languageFR from './fr/translate.json'

i18n
.use(XHR)
.use(LanguageDetector);

if (initReactI18next) {
  i18n.use(initReactI18next);
}

i18n.init({
    resources: {
        en: languageEN,
        eng: languageEN,
        lv: languageLV,
        lat: languageLV,
        ru: languageRU,
        rus: languageRU,
        es: languageES,
        esp: languageES,
        hd: languageHD,
        hi: languageHD,
        india: languageHD,
        fr: languageFR,
        fra: languageFR
    },
    
    /* default language when load the website in browser */
    lng: "en",
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: "en",
    /* debugger For Development environment */
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },
    react: {
        wait: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default'
    }
})

export default i18n;